import { render, staticRenderFns } from "./NotificationUsersModal.vue?vue&type=template&id=a914876a&scoped=true&"
import script from "./NotificationUsersModal.vue?vue&type=script&lang=js&"
export * from "./NotificationUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a914876a",
  null
  
)

export default component.exports